import { render, staticRenderFns } from "./PageText.vue?vue&type=template&id=cd3201ee&"
import script from "./PageText.vue?vue&type=script&lang=js&"
export * from "./PageText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports